// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1AC4_","sub":"Button_sub__2TEYn"};